import { InfiniteData } from '@tanstack/query-core';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { ProgramsData } from '@shared/types/programs';
import { API } from '@src/api/index.ts';
import { queryClient } from '@src/api/query-client.ts';
import { EntityByIdParam } from '@src/api/types.ts';

export const useProgramQuery = (params: EntityByIdParam) => {
  const methods = useQuery({
    queryKey: ['program', params.id],
    queryFn: async () => await API.programs.getById(params),
    enabled: typeof params?.id !== 'undefined',
  });

  useEffect(() => {
    queryClient.setQueriesData(
      { queryKey: ['programs'] },
      (oldData: InfiniteData<ProgramsData>) => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          pages: oldData.pages.map((page) => ({
            ...page,
            results: page.results.map((item) =>
              item.pk === methods.data?.pk ? { ...item, ...methods.data } : item
            ),
          })),
        };
      }
    );

    queryClient.setQueriesData(
      { queryKey: ['programsHistory'] },
      (oldData: InfiniteData<ProgramsData>) => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          pages: oldData.pages.map((page, pageIndex) => ({
            ...page,
            results: pageIndex === 0 ? [methods.data, ...page.results] : page.results,
          })),
        };
      }
    );
  }, [methods.data]);

  return methods;
};
